import { useState } from "react";
import { useEffect } from "react";

const CountdownTimer = ({ expiryTime }) => {
    const [diffInSeconds, setDiffInSeconds] = useState(0);

    useEffect(() => {
        if (!expiryTime) return;

        const updateDiff = () => {
            const now = new Date();
            const diff = Math.floor((expiryTime - now) / 1000);
            setDiffInSeconds(diff > 0 ? diff : 0);
        };

        updateDiff();
        const interval = setInterval(updateDiff, 1000);
        return () => clearInterval(interval);
    }, [expiryTime]);

    const formatTime = (seconds) => {
        const hrs = String(Math.floor(seconds / 3600)).padStart(2, "0");
        const min = String(Math.floor((seconds % 3600) / 60)).padStart(2, "0");
        const sec = String(seconds % 60).padStart(2, "0");
        return `${hrs}:${min}:${sec}`;
    };

    return <span>{formatTime(diffInSeconds)}</span>;
};
export default CountdownTimer;